import React, { useEffect, useState } from "react"
import { Box, Button, Paper, Typography } from "@mui/material"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import { colors, containedButtonStyles } from "../../../styles/commonStyles"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import {
  loadProviders,
  loadingProviders,
  cancelNewEntry,
  monthDecrement,
  monthIncrement,
  setPrimaryTab,
  setSecondayTab,
  setSelectedYear,
  setYears,
  togglePublished,
  clearTabChanges,
  syncToPNL,
  clearAllData,
} from "../../redux/slices/resourceBudgetSlice"
import { getTokenLocal } from "../../../helper/utils"
import { getYears } from "./utils"
import { MetricHeaderWrapper } from "./Atom"
import BudgetForcastSidebar from "../../components/Drawer/BudgetForecastSidebar/Index"
import ResourcesBudgetTable from "../../components/Table/ResourceBudgetTable/Index"
import { DateSlider, BudgetCopyTo } from "./Atom"
import { setLoading } from "../../redux/slices/appSlice"
import { resourceBudgetType } from "./types"
import { useNavigate } from "react-router-dom"
import ResourceBudgetTabs from "../../components/Tabs/ResourceBudgetTabs/Index"
import ResourceBudgetAPI from "../../../api/resourceBudget"
import { useResponseHandle } from "../../hooks"
import {
  genericGet,
  getProviders,
  getRoles,
  publishBudget,
  syncBudget,
  saveAllChanges,
} from "../../components/Table/ResourceBudgetTable/apiUtils"
import {
  AlertModal,
  ConfirmModal,
} from "../../components/Tabs/ResourceBudgetTabs/Atom"
import PermsWrapper from "../../components/Auth/PermsWrapper"
import { permissions } from "../../../config/constants"
import SingleSelectFilter from "../../components/Dropdown/Filters/Index"
import {
  setMaevaGroups,
  setMaevaPractices,
  setMaevaRegions,
  setMaevaSelectedGroupsNoAll,
  setMaevaSelectedPracticesNoAll,
  setMaevaSelectedRegionsNoAll,
} from "../../redux/slices/metricSlice"
import {
  fetchGroupsHandler,
  fetchOfficesHandler,
  fetchRegionsHandler,
} from "../Huddle/apiUtils"
import { NavigationAssistant } from "../Huddle/Atom"
import { primaryTabs as pT } from "./constants"
import { getYearsIndependent } from "./utils"
import { toast } from "react-toastify"

const ResourceBudget = () => {
  const navigate = useNavigate()
  const yearInitializedRef = React.useRef<boolean>(false)
  const API = new ResourceBudgetAPI()
  const state: resourceBudgetType = useAppSelector(
    (state: any) => state.resourceBudget,
  )
  const metricState: any = useAppSelector((store) => store.metric)
  const { primaryIndex, secondaryIndex, primaryTabs } = state
  const { secondayTabs, published, editState } = state
  const { years, selectedYear, dataIndex } = state
  // Filters
  const { maevaGroups, maevaRegions, maevaPractices } = metricState
  const maevaSelectedGroups = metricState.maevaSelectedGroupsNoAll
  const maevaSelectedRegions = metricState.maevaSelectedRegionsNoAll
  const maevaSelectedPractices = metricState.maevaSelectedPracticesNoAll

  const { openSidebar } = useAppSelector((state) => state.app)
  const appLoading = useAppSelector((state) => state.app.loading)
  const token: any = getTokenLocal()
  const dispatch = useAppDispatch()

  // Check if there are any unsaved changes across all months
  const monthStates = editState.monthStates || {}
  const hasUnsavedChanges =
    editState.allChanges.length > 0 ||
    Object.values(monthStates).some((monthState: any) => {
      return (
        monthState.clinicalDoctors?.data?.length > 0 ||
        monthState.clinicalHygienists?.data?.length > 0 ||
        monthState.nonClinical?.data?.length > 0 ||
        monthState.allChanges?.length > 0
      )
    }) ||
    editState.clinicalDoctors.data.length > 0 ||
    editState.clinicalHygienists.data.length > 0 ||
    editState.nonClinical.data.length > 0
  const currentMonthState = editState.monthStates?.[state.month]
  const nonClinicalChangesForMonth =
    currentMonthState?.nonClinical?.data || editState.nonClinical.data || []
  const nonClinicalDirtyForMonth =
    (currentMonthState?.nonClinical?.dirty || []).length > 0 ||
    (editState.nonClinical?.dirty || []).length > 0
  const nonClinicalHasChanges =
    nonClinicalChangesForMonth.length > 0 || nonClinicalDirtyForMonth
  const [showModel, setShowModel] = useState({
    open: false,
    loading: false,
    message: {
      title: "",
      description: "",
    },
    buttonText: "",
  })
  const [showSidebar, setShowSidebar] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [errorState, setErrorState] = useState({
    open: false,
    title: "",
    subText: "",
  })
  const [forecastSyncModal, setForecastSyncModal] = useState({
    open: false,
    loading: false,
  })
  const open = Boolean(anchorEl)

  const toggleSidebar = () => {
    setShowSidebar((prev) => !prev)
  }
  const toggleModel = () => {
    setShowModel((prev) => ({
      ...prev,
      open: !prev.open,
      message: {
        title: `Publish budget ${(selectedYear as any)?.label}`,
        description: `Do you want to publish the clinical and non-clinical budget for ${
          maevaSelectedPractices?.[0].label
        } from Jan to Dec for year ${
          (selectedYear as any)?.label
        }? You can edit data in the forecast later`,
      },
      buttonText: "Publish now",
    }))
  }

  const loading = (loadVal: boolean) => {
    if (loadVal) {
      setShowModel((prev) => ({ ...prev, loading: loadVal }))
    } else {
      setShowModel((prev) => ({ ...prev, open: false, loading: false }))
    }
  }
  const setAppLoading = (loadVal: boolean) => dispatch(setLoading(loadVal))

  const closeAlertModal = () => {
    setErrorState((prev) => ({ ...prev, open: false }))
  }
  const closeForecastSyncModal = () => {
    setForecastSyncModal((prev) => ({ ...prev, open: false, loading: false }))
  }
  const handleForecastSync = async () => {
    setForecastSyncModal((prev) => ({ ...prev, loading: true }))

    try {
      const payload = {
        year: (selectedYear as any)?.label,
        practice_sk: maevaSelectedPractices?.[0]?.practice_sk,
      }

      const response = await API.copyToForecast({
        token,
        payload,
      })

      const result = useResponseHandle({
        apiResponse: response,
        successMessage: false,
      })

      if (result?.isAuthorized && result?.statusCode === 200) {
        toast.success("Budget successfully synced to forecast!")
      } else {
        setError("Failed to sync budget to forecast. Please try again.")
      }
    } catch (error) {
      console.error("Forecast sync error:", error)
      setError("Failed to sync budget to forecast. Please try again.")
    } finally {
      setForecastSyncModal((prev) => ({ ...prev, open: false, loading: false }))
    }
  }
  const setError = (error: string) => {
    const [title, subText] = error?.split("-")
    setErrorState({ open: true, title, subText })
  }
  const publishHandler = () => {
    publishBudget({
      office: maevaSelectedPractices?.[0],
      year: selectedYear,
      token,
      loading,
      setError,
      navigate,
      dispatch: () => dispatch(togglePublished({})),
    })
  }
  const saveHandler = () => {
    saveAllChanges({
      editState,
      office: maevaSelectedPractices?.[0],
      year: selectedYear,
      month: state.month,
      token,
      loading,
      setError,
      onSuccess: () => {
        // Clear all changes after successful save
        dispatch(syncToPNL({}))
        // Show forecast sync modal
        setForecastSyncModal((prev) => ({ ...prev, open: true }))
      },
    })
  }

  const saveNonClinicalHandler = () => {
    // Only for non-clinical tab
    if (primaryIndex !== 1) return

    if (!selectedYear || !maevaSelectedPractices?.length || !token) {
      toast.error("Select office and year before saving.")
      return
    }

    const monthSpecificChanges = nonClinicalChangesForMonth.filter(
      (change: any) => {
        return change?.month === undefined || change?.month === state.month
      },
    )

    if (monthSpecificChanges.length === 0 && !nonClinicalDirtyForMonth) {
      toast.info("No non-clinical changes to save.")
      return
    }

    const nonClinicalOnlyEditState = {
      ...editState,
      clinicalDoctors: { ...editState.clinicalDoctors, data: [] },
      clinicalHygienists: { ...editState.clinicalHygienists, data: [] },
      nonClinical: {
        ...editState.nonClinical,
        data: monthSpecificChanges,
      },
      allChanges: monthSpecificChanges,
    }

    setAppLoading(true)
    saveAllChanges({
      editState: nonClinicalOnlyEditState,
      office: maevaSelectedPractices?.[0],
      year: selectedYear,
      month: state.month,
      token,
      loading: setAppLoading,
      setError,
      onSuccess: () => {
        dispatch(
          clearTabChanges({
            tabKey: "nonClinical",
            month: state.month,
          }),
        )
        toast.success("Non-clinical hours saved.")
      },
    })
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const groupChangeHandler = React.useCallback(
    (_: any, value: any) => {
      dispatch(clearAllData()) // Clear all data when group changes
      dispatch(setMaevaSelectedGroupsNoAll([value?.props?.value]))
      dispatch(setMaevaSelectedRegionsNoAll([]))
      dispatch(setMaevaSelectedPracticesNoAll([]))
      // Remove the year reset to keep year selection independent
    },
    [dispatch],
  )

  const regionChangeHandler = React.useCallback(
    (_: any, value: any) => {
      dispatch(clearAllData()) // Clear all data when region changes
      dispatch(setMaevaSelectedRegionsNoAll([value?.props?.value]))
      dispatch(setMaevaSelectedPracticesNoAll([]))
    },
    [dispatch],
  )

  const officeChangeHandler = React.useCallback(
    (_: any, value: any) => {
      dispatch(clearAllData()) // Clear all data when practice/office changes
      dispatch(setMaevaSelectedPracticesNoAll([value?.props?.value]))
    },
    [dispatch],
  )

  const yearChangeHandler = React.useCallback(
    (_: any, value: any) => {
      dispatch(clearAllData()) // Clear all data and dirty states when year changes
      dispatch(cancelNewEntry())
      dispatch(setSelectedYear(value?.props?.value))
    },
    [dispatch],
  )

  // get filters
  React.useEffect(() => {
    if (!maevaGroups?.length) {
      fetchGroupsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaGroups(payload))
        },
        navigate,
        loading: setAppLoading,
      })
    }
  }, []) // get groups

  React.useEffect(() => {
    if (maevaSelectedGroups?.length) {
      fetchRegionsHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaRegions(payload))
        },
        navigate,
        group: maevaSelectedGroups?.[0],
        loading: setAppLoading,
      })
    }
  }, [maevaSelectedGroups]) // get regions with group sk

  React.useEffect(() => {
    if (maevaSelectedRegions?.length) {
      fetchOfficesHandler({
        token,
        dispatch: (payload: any) => {
          dispatch(setMaevaPractices(payload))
        },
        navigate,
        loading: setAppLoading,
        group: maevaSelectedGroups?.[0],
        region: maevaSelectedRegions?.[0],
      })
    }
  }, [maevaSelectedRegions]) // get offices with region

  React.useEffect(() => {
    // Fetch years when component loads, independent of any selection
    if (maevaGroups?.length) {
      // Use the first available group to fetch years
      getYearsIndependent({
        token,
        dispatch: (payload: any) => {
          dispatch(setYears(payload))
        },
        navigate,
        loading: setAppLoading,
        group: maevaGroups[0],
      })
    }
  }, [maevaGroups]) // Fetch years when groups are loaded

  // Set current year as default when years are loaded (only once)
  // Note: Years are sorted in descending order, but we specifically search for current year
  // to ensure it's selected even if it's not the first in the list
  React.useEffect(() => {
    if (years?.length && !selectedYear && !yearInitializedRef.current) {
      const currentYear = new Date().getFullYear()
      // Search for current year in the sorted list (works regardless of sort order)
      // Convert both to numbers for reliable comparison to handle string/number formats
      const currentYearOption = years.find((year: any) => {
        const yearValue = typeof year.label === 'number' ? year.label : parseInt(year.label)
        return yearValue === currentYear
      })
      if (currentYearOption) {
        // Select current year if found
        dispatch(setSelectedYear(currentYearOption))
      } else if ((years as any[]).length > 0) {
        // If current year not found, select the first available year (most recent due to descending sort)
        dispatch(setSelectedYear((years as any[])[0]))
      }
      yearInitializedRef.current = true
    }
  }, [years]) // Remove selectedYear from dependencies to prevent reset

  useEffect(() => {
    if (selectedYear && maevaSelectedPractices?.length) {
      // Make all API calls on first load to load all data
      // This ensures data is available for all tabs without re-fetching on tab switch

      // Always fetch Clinical data (both Doctors and Hygienists)
      genericGet[primaryTabs[0]]({
        token,
        dispatch,
        office: maevaSelectedPractices?.[0],
        year: selectedYear,
        month: state.month,
        secondaryIndex: 0, // Doctors
      })

      genericGet[primaryTabs[0]]({
        token,
        dispatch,
        office: maevaSelectedPractices?.[0],
        year: selectedYear,
        month: state.month,
        secondaryIndex: 1, // Hygienists
      })

      // Always fetch Non-clinical data
      genericGet[primaryTabs[1]]({
        token,
        dispatch,
        office: maevaSelectedPractices?.[0],
        year: selectedYear,
        month: state.month,
        // Don't pass secondaryIndex for non-clinical to distinguish from clinical data
      })
    }
  }, [
    selectedYear,
    maevaSelectedPractices,
    state.month,
    // Remove primaryIndex to prevent re-fetching on tab switch
    // Remove secondaryIndex to prevent re-fetching on tab switch
  ])

  // Track previous data to avoid infinite loops on tab reload
  const prevDataRef = React.useRef<{
    doctorsData: any[] | undefined
    hygienistsData: any[] | undefined
    nonClinicalData: any[] | undefined
  }>({
    doctorsData: undefined,
    hygienistsData: undefined,
    nonClinicalData: undefined,
  })

  useEffect(() => {
    // Avoid re-dispatching while a new entry row exists (prevents clearing the table)
    if (state.editState.newEntry) return

    const doctorsChanged =
      state.doctorsData && prevDataRef.current.doctorsData !== state.doctorsData
    const hygienistsChanged =
      state.hygienistsData &&
      prevDataRef.current.hygienistsData !== state.hygienistsData
    const nonClinicalChanged =
      state.nonClinicalData &&
      prevDataRef.current.nonClinicalData !== state.nonClinicalData

    // Only trigger setPrimaryTab if data was ADDED (length increased), not removed (deleted)
    // This prevents restoring deleted items
    const doctorsAdded =
      doctorsChanged &&
      (prevDataRef.current.doctorsData?.length || 0) <
        (state.doctorsData?.length || 0)
    const hygienistsAdded =
      hygienistsChanged &&
      (prevDataRef.current.hygienistsData?.length || 0) <
        (state.hygienistsData?.length || 0)
    const nonClinicalAdded =
      nonClinicalChanged &&
      (prevDataRef.current.nonClinicalData?.length || 0) <
        (state.nonClinicalData?.length || 0)

    if (doctorsChanged) prevDataRef.current.doctorsData = state.doctorsData
    if (hygienistsChanged)
      prevDataRef.current.hygienistsData = state.hygienistsData
    if (nonClinicalChanged)
      prevDataRef.current.nonClinicalData = state.nonClinicalData

    if (state.primaryIndex === 0) {
      const dataChanged =
        state.secondaryIndex === 0 ? doctorsAdded : hygienistsAdded
      if (dataChanged) {
        dispatch(setPrimaryTab(state.primaryIndex))
      }
    } else if (nonClinicalAdded) {
      dispatch(setPrimaryTab(state.primaryIndex))
    }
  }, [
    state.doctorsData,
    state.hygienistsData,
    state.nonClinicalData,
    state.primaryIndex,
    state.secondaryIndex,
    dispatch,
  ])

  const defaultEditMode = React.useMemo(
    () => dataIndex === pT.nonClinical,
    [dataIndex],
  )
  React.useEffect(() => {
    if (!defaultEditMode) {
      getProviders({
        dispatch: (data: any) => dispatch(loadProviders(data)),
        loading: (loadVal: boolean) => dispatch(loadingProviders(loadVal)),
        token,
        office: maevaSelectedPractices?.[0],
        secondaryIndex,
      })
    } else {
      {
        getRoles({
          dispatch: (data: any) => dispatch(loadProviders(data)),
          loading: (loadVal: boolean) => loadingProviders(loadVal),
          token,
        })
      }
    }
  }, [dataIndex, maevaSelectedPractices])

  const navigationData = React.useMemo(
    () => [
      {
        label: "Select a group to proceed",
        value: maevaSelectedGroups?.length ? true : false,
      },
      {
        label: "Select a region to proceed",
        value: maevaSelectedRegions?.length ? true : false,
      },
      {
        label: "Select a office to proceed",
        value: maevaSelectedPractices?.length ? true : false,
      },
      {
        label: "Select a year to proceed",
        value: selectedYear ? true : false,
      },
    ],
    [
      maevaSelectedGroups,
      maevaSelectedPractices,
      maevaSelectedRegions,
      selectedYear,
    ],
  )

  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "89vh",
          flexDirection: "column",
          backgroundColor: colors.background,
        }}
      >
        <MetricHeaderWrapper
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            maxHeight: "80px",
            mb: "15px",
            padding: "15px 20px 15px 20px",
          }}
        >
          <Box sx={{ margin: 0 }}>
            <Typography fontWeight={600} fontSize={"16px"}>
              Resource Budget
            </Typography>
            <Box
              sx={{ color: "#888888", cursor: "pointer" }}
              onClick={() => navigate(-1)}
            >
              <KeyboardArrowLeftIcon sx={{ fontSize: "12px" }} /> Back
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              mr: "10px",
            }}
          >
            <SingleSelectFilter
              key={"p&l-1"}
              disabled={appLoading}
              changeHandler={groupChangeHandler}
              filterData={maevaGroups}
              filterLabel={"Group Name"}
              selectedValue={maevaSelectedGroups?.[0] || null}
              placeHolder={"Select a group"}
              width={190}
            />
            <SingleSelectFilter
              key={"p&l-2"}
              disabled={!maevaSelectedGroups?.length || appLoading}
              changeHandler={regionChangeHandler}
              filterData={maevaRegions}
              filterLabel={"Regions"}
              selectedValue={maevaSelectedRegions?.[0] || null}
              placeHolder={"Select a region"}
              width={190}
            />
            <SingleSelectFilter
              key={"p&l-3"}
              disabled={!maevaSelectedRegions?.length || appLoading}
              changeHandler={officeChangeHandler}
              placeHolder={"Select an office"}
              selectedValue={maevaSelectedPractices?.[0] || null}
              filterData={maevaPractices}
              filterLabel={"Offices"}
              width={190}
            />
            <SingleSelectFilter
              key={"p&l-4"}
              disabled={appLoading}
              changeHandler={yearChangeHandler}
              placeHolder={"Select a year"}
              selectedValue={selectedYear || null}
              filterData={years}
              filterLabel={"Year"}
              width={190}
            />
          </Box>

          {selectedYear && maevaSelectedPractices?.length ? (
            <Box
              sx={{
                display: "flex",
                mt: "30px",
                gap: "10px",
                justifyContent: "center",
              }}
            >
              {/* Global Save Button */}
              {(editState.allChanges.length > 0 ||
                editState.clinicalDoctors.data.length > 0 ||
                editState.clinicalHygienists.data.length > 0 ||
                editState.nonClinical.data.length > 0 ||
                Object.values(monthStates).some((monthState: any) => {
                  return (
                    monthState.clinicalDoctors?.data?.length > 0 ||
                    monthState.clinicalHygienists?.data?.length > 0 ||
                    monthState.nonClinical?.data?.length > 0 ||
                    monthState.allChanges?.length > 0
                  )
                })) && (
                <PermsWrapper perm={permissions.BEFORE_PUBLISH_OPERATION}>
                  <Button
                    disabled={appLoading}
                    variant="contained"
                    sx={{
                      ...containedButtonStyles,
                      minHeight: "40px",
                      minWidth: "80px",
                      px: 1,
                      fontSize: "14px",
                      backgroundColor: "#28a745",
                      "&:hover": {
                        backgroundColor: "#218838",
                      },
                    }}
                    onClick={saveHandler}
                  >
                    Save All
                  </Button>
                </PermsWrapper>
              )}

              {/* Non-clinical specific save */}
              {/* {primaryIndex === 1 && nonClinicalHasChanges && (
                <PermsWrapper perm={permissions.BEFORE_PUBLISH_OPERATION}>
                  <Button
                    disabled={appLoading}
                    variant="contained"
                    sx={{
                      ...containedButtonStyles,
                      minHeight: "40px",
                      minWidth: "130px",
                      px: 1.5,
                      fontSize: "14px",
                      backgroundColor: "#1a73e8",
                      "&:hover": {
                        backgroundColor: "#1558b0",
                      },
                    }}
                    onClick={saveNonClinicalHandler}
                  >
                    Save Non-Clinical
                  </Button>
                </PermsWrapper>
              )} */}

              {!published && !hasUnsavedChanges && (
                <PermsWrapper perm={permissions.PUBLISH_BUDGET}>
                  <Button
                    variant="contained"
                    disabled={appLoading}
                    sx={{
                      ...containedButtonStyles,
                      minHeight: "40px",
                      px: 3,
                      fontSize: "14px",
                    }}
                    onClick={toggleModel}
                  >
                    {`Publish ${(selectedYear as any)?.label || ""}`}
                  </Button>
                </PermsWrapper>
              )}
              {published && (
                <PermsWrapper perm={permissions.VIEW_RESOURCE_FORECAST}>
                  <Button
                    variant="contained"
                    disabled={appLoading}
                    sx={{
                      ...containedButtonStyles,
                      minHeight: "40px",
                      minWidth: openSidebar ? "130px" : "145px",
                      px: 1,
                      fontSize: "14px",
                    }}
                    onClick={toggleSidebar}
                  >
                    {"View Forecast"}
                  </Button>
                </PermsWrapper>
              )}
            </Box>
          ) : (
            <Box />
          )}
        </MetricHeaderWrapper>
        {selectedYear && maevaSelectedPractices?.length ? (
          <Paper
            sx={{
              margin: "25px 20px 5px 20px",
              display: "flex",
              flexGrow: 1,
              flexDirection: "column",
            }}
          >
            <ResourceBudgetTabs
              dirty={false} // Allow tab switching
              tabValues={primaryTabs}
              index={primaryIndex}
              dispatchFun={setPrimaryTab}
              optionsContainerStyles={{ paddingBottom: "5px" }}
              additionalOptions={[
                <DateSlider
                  dirty={false} // Allow month switching
                  month={state.month}
                  year={selectedYear}
                  key={"date-slider"}
                  monthIncrement={monthIncrement}
                  monthDecrement={monthDecrement}
                />,
                !published && (
                  <PermsWrapper perm={permissions?.BEFORE_PUBLISH_OPERATION}>
                    <BudgetCopyTo
                      key={"month-selector"}
                      open={open}
                      label={primaryTabs[primaryIndex].replace("Hours", "")}
                      close={handleClose}
                      onClick={handleClick}
                      anchorEl={anchorEl}
                    />
                  </PermsWrapper>
                ),
              ]}
            />

            <ResourceBudgetTabs
              dirty={false} // Allow tab switching
              dispatchFun={setSecondayTab}
              tabValues={secondayTabs[primaryIndex]}
              index={secondaryIndex}
            />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                position: "relative",
                flexGrow: 1,
              }}
            >
              <ResourcesBudgetTable
                onDeleteSuccess={() => {
                  // Show forecast sync modal after successful deletion
                  setForecastSyncModal((prev) => ({ ...prev, open: true }))
                }}
              />
            </Box>
          </Paper>
        ) : (
          <Box
            sx={{
              mt: 3,
            }}
          >
            <NavigationAssistant data={navigationData} />
          </Box>
        )}
      </Box>
      <ConfirmModal
        close={toggleModel}
        open={showModel.open}
        title={showModel.message.title}
        optionalMessage={showModel.message.description}
        confirmButtonText={showModel.buttonText}
        cancelButtonText="Cancel"
        confirmActionHandler={publishHandler}
        api={{
          loading: showModel.loading,
        }}
      />
      <AlertModal
        close={closeAlertModal}
        open={errorState.open}
        title={errorState.title}
        optionalMessage={errorState.subText}
        buttonText={"Close"}
      />
      <ConfirmModal
        close={closeForecastSyncModal}
        open={forecastSyncModal.open}
        title="Sync Budget to Forecast"
        optionalMessage="Do you want to sync the budget to forecast?"
        confirmButtonText="Yes"
        cancelButtonText="No"
        confirmActionHandler={handleForecastSync}
        api={{
          loading: forecastSyncModal.loading,
        }}
      />
      <BudgetForcastSidebar open={showSidebar} toggleOpen={toggleSidebar} />
    </>
  )
}

export default ResourceBudget
